function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJava = function SvgJava(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 213.02 288.83",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M68.61,223.37s-11.04,6.42,7.86,8.59c22.89,2.61,34.59,2.24,59.81-2.54,0,0,6.63,4.16,15.89,7.76-56.54,24.23-127.97-1.4-83.56-13.81",
    style: {
      fill: "#5382a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7,191.75s-12.38,9.16,6.53,11.12c24.45,2.52,43.76,2.73,77.17-3.7,0,0,4.62,4.69,11.89,7.25-68.36,19.99-144.51,1.58-95.58-14.66",
    style: {
      fill: "#5382a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,138.11c13.93,16.04-3.66,30.47-3.66,30.47,0,0,35.38-18.26,19.13-41.13-15.17-21.33-26.81-31.92,36.18-68.46,0,0-98.88,24.7-51.65,79.11",
    style: {
      fill: "#f8981d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,246.76s8.17,6.73-9,11.94c-32.64,9.89-135.84,12.87-164.51.39-10.31-4.48,9.02-10.71,15.1-12.01,6.34-1.37,9.96-1.12,9.96-1.12-11.46-8.07-74.08,15.85-31.81,22.71,115.28,18.7,210.15-8.42,180.25-21.91",
    style: {
      fill: "#5382a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.91,158.98s-52.49,12.47-18.59,17c14.32,1.92,42.85,1.48,69.44-.74,21.72-1.83,43.54-5.73,43.54-5.73,0,0-7.66,3.28-13.2,7.06-53.31,14.02-156.29,7.5-126.64-6.84,25.07-12.12,45.46-10.74,45.46-10.74",
    style: {
      fill: "#5382a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,211.62c54.19-28.16,29.13-55.22,11.65-51.57-4.29.89-6.2,1.67-6.2,1.67,0,0,1.59-2.49,4.63-3.57,34.6-12.16,61.2,35.87-11.17,54.9,0,0,.84-.75,1.09-1.42",
    style: {
      fill: "#5382a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,0s30.01,30.02-28.46,76.19c-46.89,37.03-10.69,58.15-.02,82.27-27.37-24.7-47.46-46.44-33.98-66.67C92.73,62.09,147.52,47.69,135.41,0",
    style: {
      fill: "#f8981d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.24,287.93c52.02,3.33,131.89-1.85,133.78-26.46,0,0-3.64,9.33-42.99,16.74-44.4,8.35-99.15,7.38-131.63,2.02,0,0,6.65,5.5,40.83,7.69",
    style: {
      fill: "#5382a1"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJava, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "java.svg";
export { ForwardRef as ReactComponent };